import { render } from "./anc_treatment.vue?vue&type=template&id=254d764d&scoped=true"
import script from "./anc_treatment.vue?vue&type=script&lang=js"
export * from "./anc_treatment.vue?vue&type=script&lang=js"

import "./anc_treatment.vue?vue&type=style&index=0&id=254d764d&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254d764d"]])

export default __exports__